import React from 'react';
import { IMG_WIDTH, IMG_HEIGHT } from '~/config/constants';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { IMAGE_NOT_AVAILABLE } from '~/config/constants';
import { useErrorPicture } from '~/hooks/useErrorPicture';
import { escapeSpecialCharsInFilename } from '~/utils/helpers';
import { useImageNotAvailable } from '~/hooks/useImageNotAvailable';

function PreviewAsBackground({ pictureUrl, width, height, inputEl, id, wrapperClass, wrapperStyle }) {
    const err = useErrorPicture(pictureUrl);
    const img = useImageNotAvailable(pictureUrl);

    return (
        <div
            style={{
                backgroundImage: `url('${escapeSpecialCharsInFilename(pictureUrl)}')`,
                backgroundSize: 'contain',
                width: width || IMG_WIDTH,
                height: height || IMG_HEIGHT,
                cursor: inputEl ? 'pointer' : 'auto',
                ...wrapperStyle,
            }}
            className={cx(`position-relative text-center mb-3 ${wrapperClass}`, {
                'border border-dark rounded': img === IMAGE_NOT_AVAILABLE || err,
            })}
            onClick={() => {
                if (inputEl) {
                    inputEl.current.click();
                    inputEl.current.focus(); //need to have focus() here so that on blur event will be fired when clicking away.
                }
            }}
            id={id}
        >
            {err && (
                <img
                    src={IMAGE_NOT_AVAILABLE}
                    className="position-relative"
                    style={{ width: '100%', top: '25%', left: 0 }}
                />
            )}
        </div>
    );
}

PreviewAsBackground.defaultProps = {
    width: '',
    height: '',
    id: '',
    wrapperClass: '',
    wrapperStyle: {},
    inputEl: null,
};
PreviewAsBackground.propTypes = {
    pictureUrl: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputEl: PropTypes.object,
    id: PropTypes.string,
    wrapperClass: PropTypes.string,
    wrapperStyle: PropTypes.object,
};
export default React.memo(PreviewAsBackground);
